import React from "react";

import Header from "components/Library/Header";

import styles from "./EventsSectionStreamHeader.css";

export default function EventsSectionStreamHeader() {
  return <Header className={styles.root} text="Events" />;
}
